import { render } from "./PredictionMainTable.vue?vue&type=template&id=7a37d8d1"
import script from "./PredictionMainTable.vue?vue&type=script&lang=js"
export * from "./PredictionMainTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__